import { translate as t } from '../lib/I18n';

import AppDispatcher from '../dispatcher/AppDispatcher';
import { ActionTypes } from '../constants/AppConstants';
import StationService from '../services/StationService';

const StationFinderActions = {
    async findNearest ({ latitude, longitude, searchInteraction }) {

        AppDispatcher.dispatch({
            actionType: ActionTypes.STATION_FINDER_SEARCH_STARTED,
            latitude,
            longitude,
            searchInteraction
        });

        try {
            const stations = await StationService.findNearest(latitude, longitude);
            if (stations.size) {
                AppDispatcher.dispatch({
                    actionType: ActionTypes.STATION_FINDER_SEARCH_COMPLETE,
                    stations,
                });
            } else {
                AppDispatcher.dispatch({
                    actionType: ActionTypes.STATION_FINDER_SEARCH_FAILED,
                    error: new Error(t('stationFinder.search.error')),
                });
                AppDispatcher.dispatch({ actionType: ActionTypes.STATION_FINDER_SET_EXPANDED, value: true });
            }
        } catch (error) {
            console.error('Error searching for stations', error);
            AppDispatcher.dispatch({
                actionType: ActionTypes.STATION_FINDER_SEARCH_FAILED,
                error
            });
            AppDispatcher.dispatch({ actionType: ActionTypes.STATION_FINDER_SET_EXPANDED, value: true });
        }
    },

    clearStations () {
        AppDispatcher.dispatch({ actionType: ActionTypes.STATION_FINDER_STATIONS_CLEARED });
    },

    clearError () {
        AppDispatcher.dispatch({ actionType: ActionTypes.STATION_FINDER_ERROR_CLEARED });
    },

    setExpanded (value) {
        AppDispatcher.dispatch({ actionType: ActionTypes.STATION_FINDER_SET_EXPANDED, value });
    },

    setStationSelected (originDest, station) {
        AppDispatcher.dispatch({ actionType: ActionTypes.STATION_FINDER_STATION_SELECTED, originDest, station });
    },

    async getTicketOfficeDetails (station) {
        const ticketOffice = await StationService.getTicketOfficeDetails(station);
        AppDispatcher.dispatch({
            actionType: ActionTypes.STATION_FINDER_TICKET_OFFICE_LOADED,
            station,
            ticketOffice
        });
        return ticketOffice;
    }
};

export default StationFinderActions;



// WEBPACK FOOTER //
// ./src/actions/StationFinderActions.js